export { default } from "./delete-post-alert-dialog";
